import React from 'react';
import styled from 'styled-components';
import VideoCarousel from '../../components/VideoCarousel';
import ProductCarousel from '../../components/ProductCarousel';
import { categories, products } from '../../data/products';

const PageContainer = styled.div`
  background: ${({ theme }) => theme.colors.background};
  min-height: 100vh;
  overflow: hidden;
  padding: 0 20px;
  background: linear-gradient(135deg,rgb(255, 255, 200) 0%, #c3cfe2 100%);
`;

const Section = styled.section`
  padding: ${({ theme }) => theme.spacing.xlarge} 0;
  position: relative;
  text-align: center;
  margin: 20px 0;
  border-radius: 10px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  
`;

const SectionTitle = styled.h2`
  margin-bottom: ${({ theme }) => theme.spacing.xlarge};
  color: ${({ theme }) => theme.colors.gold.main};
  font-family: ${({ theme }) => theme.fonts.primary};
  font-size: 2.5rem;
  position: relative;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  animation: fadeIn 1s ease-in-out;
  transition: color 0.3s ease, transform 0.3s ease;

  &:hover {
    color: ${({ theme }) => theme.colors.primary};
    transform: scale(1.05);
  }

  &::after {
    content: '';
    position: absolute;
    bottom: -10px;
    left: 50%;
    transform: translateX(-50%);
    width: 100px;
    height: 2px;
    background: ${({ theme }) => theme.colors.gradients.primary};
  }

  @keyframes fadeIn {
    from {
      opacity: 0;
      transform: translateY(20px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
`;

const CategorySection = styled(Section)`
  background: linear-gradient(
    135deg,
    ${({ theme }) => theme.colors.background} 0%,
    ${({ theme }) => theme.colors.secondary} 100%
  );
`;

const FeaturedSection = styled(Section)`
  background: linear-gradient(135deg,rgb(255, 255, 200) 0%, #c3cfe2 100%);
`;

const LandingPage = () => {
  const categoryProducts = categories.map(category => ({
    id: category.id,
    name: category.name,
    images: [category.image],
    price: '',
    description: category.description
  }));

  const featuredProducts = products.filter(product => product.featured);

  return (
    <PageContainer>
      <VideoCarousel />
      
      <CategorySection>
        <SectionTitle>Exquisite Collections</SectionTitle>
        <ProductCarousel products={categoryProducts} />
      </CategorySection>

      <FeaturedSection>
        <SectionTitle>Featured Pieces</SectionTitle>
        <ProductCarousel products={featuredProducts} />
      </FeaturedSection>
    </PageContainer>
  );
};

export default LandingPage;